<template>
  <button
    class="w-36 px-3 py-1 bg-white border-2 border-red-600 rounded shadow text-center text-red-600 hover:shadow-lg hover:bg-red-600 hover:text-white transition duration-200 ease-in-out"
  >
    <slot></slot>
  </button>
</template>
